import iconArrowDown from '../../../../assets/images/StockAnalysis/icon-arrow-down-white-50.svg'
import { Select } from 'antd'
import LeftValue from './Value/LeftValue'
import ChartProcess from './Growth/ChartProcess'

import './Value.scss'
import ChartValuation from './Value/ChartValuation'
import FilterThiTruong from 'components/common/FilterThiTruong'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import useChart from 'hook/useChart'
import useA from 'hook/useA'

export default function Value() {
  const [filter, setFilter] = useState({ stock: '', time: '1M' })
  const { fetchValue } = useChart()
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore)
  const AStore = useSelector((state: any) => state?.AStore)
  const { compareDataOverview } = useA()
  const dataOverview = compareDataOverview(AStore?.Overview, AStore?.IcbOverviewV4)

  const data = [
    {
      title: 'P/E ',
      chartStart: { valueShow: `${dataOverview?.pe_value?.[0]}`, value: dataOverview?.pe?.[0], color: '#F7931A' },
      chartEnd: { valueShow: `${dataOverview?.pe_value?.[1]}`, value: dataOverview?.pe?.[1], color: '#F7931A' }
    },
    {
      title: 'P/B',
      chartStart: { valueShow: `${dataOverview?.pb_value?.[0]}`, value: dataOverview?.pb?.[0], color: '#F7931A' },
      chartEnd: { valueShow: `${dataOverview?.pb_value?.[1]}`, value: dataOverview?.pb?.[1], color: '#F7931A' }
    },
    // {
    //   title: 'Cổ tức',
    //   chartStart: { valueShow: dataOverview?.dividenYield_value?.[0], value: dataOverview?.dividenYield?.[0], color: '#F7931A' },
    //   chartEnd: { valueShow: dataOverview?.dividenYield_value?.[1], value: dataOverview?.dividenYield?.[1], color: '#F7931A' }
    // },
    {
      title: 'EV/EBITDA',
      chartStart: { valueShow: `${dataOverview?.evEbitda_value?.[0]}`, value: dataOverview?.evEbitda?.[0], color: '#F7931A' },
      chartEnd: { valueShow: `${dataOverview?.evEbitda_value?.[1]}`, value: dataOverview?.evEbitda?.[1], color: '#F7931A' }
    },
  ]

  useEffect(() => {
    setFilter({ ...filter, stock: StocksAnalysisStore?.inputSearch })
  }, [StocksAnalysisStore?.inputSearch])

  useEffect(() => {
    fetchValue({ ticker: filter.stock, cycle: filter?.time })
  }, [filter])

  const handleChangeFilter = (value: string) => {
    setFilter({ ...filter, time: value })
  }

  return (
    <>
      <div className='XqWKKMmfOA'>
        <div className='GEcySEpMtD'>
          <FilterThiTruong defaultData={filter?.time} setSelectOption={(value: string) => handleChangeFilter(value)}
            data={[
              { name: '1M', value: '1M' },
              { name: '3M', value: '3M' },
              { name: '1Y', value: '1Y' },
              { name: '2Y', value: '2Y' },
            ]} />
          <div className='brSGVNciRb'>
            {/* <select style={{ width: 109 }} className="foksrkiwxa" placeholder="Lựa chọn">
              <option>Lựa chọn </option>
            </select> */}
          </div>
        </div>
        <div className='rVWOYpEujO'>
          <div className='ngtwtxvNaT'>
            <LeftValue time={filter?.time} />
          </div>
        </div>
        <div className='hylgpvbkxt'>
          <div className='qbaiarizyi'>
            <ChartProcess data={data} title="So sánh với ngành" />
          </div>
          <div className='tdyvririqy'>
            <ChartValuation />
          </div>
        </div>
      </div>
    </>
  )
}